var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`brand-${_vm.currentBrandName} bp-${_vm.currentBreakpoint} ${
      _vm.hasTouch ? 'has-touch' : 'no-touch'
    }`},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }